<template>
	<el-container class="page-x" direction="vertical">
		<div class="search-x">
			<div class="search-item">
				<span class="label">用户名</span>
				<el-input
					class="input-box"
					clearable
					v-model="searchBox.loginName"
				></el-input>
			</div>
			<div class="search-item">
				<span class="label">姓名</span>
				<el-input
					class="input-box"
					clearable
					v-model="searchBox.realName"
				></el-input>
			</div>
			<div class="search-item">
				<span class="label">手机号</span>
				<el-input
					class="input-box"
					clearable
					v-model="searchBox.mobile"
				></el-input>
			</div>
			<div class="search-item">
				<span class="label">归属渠道</span>
				<el-select
					v-model="searchBox.dataSource"
					clearable
					placeholder="请选择"
				>
					<el-option
						v-for="item in userSource"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					>
					</el-option>
				</el-select>
			</div>
			<el-button
				v-auth="'sa_admin_index'"
				type="primary"
				class="search-btn"
				@click="search"
				>查询</el-button
			>
			<el-button
				class="search-btn"
				v-auth="'sa_item_page'"
				type="primary"
				@click="() => ($root.showPage = false)"
				>重置</el-button
			>
			<el-button
				v-auth="'sa_admin_save'"
				type="warning"
				class="search-btn"
				@click="toAdd(null, 1)"
				>添加</el-button
			>
			<!-- <el-button v-auth="'sa_admin_save'"  type="warning" class="search-btn" @click="dialogVisibleImport = true">批量添加</el-button> -->
		</div>
		<div class="table-x" ref="tableBox">
			<el-table
				v-loading="loading"
				:data="tableData"
				:height="tableHeight"
				border
				class="mb10"
			>
				<el-table-column
					type="index"
					align="center"
					label="序号"
					width="80"
				>
				</el-table-column>
				<el-table-column
					prop="oaId"
					align="center"
					label="ID"
					min-width="80"
				>
				</el-table-column>
				<el-table-column
					prop="loginName"
					align="center"
					label="用户名"
					min-width="100"
				>
				</el-table-column>
				<el-table-column
					prop="realName"
					align="center"
					label="使用人"
					min-width="100"
				>
				</el-table-column>
				<el-table-column
					prop="mobile"
					align="center"
					label="手机号"
					min-width="110"
				>
				</el-table-column>
				<el-table-column
					prop="email"
					align="center"
					label="邮箱"
					min-width="120"
				>
				</el-table-column>
				<el-table-column
					prop="org"
					align="center"
					label="机构/组织架构"
					min-width="110"
				>
				</el-table-column>
				<el-table-column
					prop="roleNames"
					align="center"
					label="角色"
					min-width="140"
				>
				</el-table-column>
				<el-table-column
					prop="dataSource"
					align="center"
					label="来源"
					min-width="140"
				>
					<template slot-scope="scope">
						{{ scope.row.dataSource | optionsFilter(userSource) }}
					</template>
				</el-table-column>
				<el-table-column align="center" label="状态">
					<template slot-scope="scope">
						{{ scope.row.adminStatus ? "正常" : "禁用" }}
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="220" align="center">
					<template slot-scope="scope">
						<el-button-group>
							<el-button
								v-auth="'sa_admin_save'"
								type="text"
								size="small"
								class="table-btn"
								@click="toAdd(scope.row, 2)"
								>详情</el-button
							>
							<el-button
								v-auth="'sa_admin_save'"
								type="text"
								size="small"
								class="table-btn"
								@click="toAdd(scope.row, 3)"
								v-if="scope.row.sourceType !== 1"
								>修改</el-button
							>
							<el-button
								v-auth="'sa_role_user_allot'"
								type="text"
								size="small"
								class="table-btn"
								@click="roleShare(scope.row)"
								v-if="scope.row.sourceType !== 1"
								>角色分配</el-button
							>
							<el-button
								v-auth="'sa_admin_reset_pwd'"
								type="text"
								size="small"
								class="table-btn"
								@click="resetPassWord(scope.row)"
								v-if="scope.row.sourceType !== 1"
								>重置密码</el-button
							>
							<el-button
								v-auth="'sa_admin_shelf'"
								v-if="
									scope.row.adminStatus === 0 &&
									scope.row.sourceType !== 1
								"
								type="text"
								size="small"
								class="table-btn"
								@click="toUpOrDown(scope.row, 1)"
								>启用</el-button
							>
							<el-button
								v-auth="'sa_admin_shelf'"
								v-if="
									scope.row.adminStatus === 1 &&
									scope.row.sourceType !== 1
								"
								type="text"
								size="small"
								class="table-btn"
								@click="toUpOrDown(scope.row, 0)"
								>禁用</el-button
							>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 分页部分 -->
		<div class="pagenation-x">
			<div class="pagination mb20">
				<el-pagination
					@current-change="handleCurrentChange"
					:current-page.sync="searchBox.pageNum"
					@size-change="getData"
					:page-sizes="[10, 50, 100]"
					:page-size.sync="searchBox.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
					background
				>
				</el-pagination>
			</div>
		</div>
		<!-- 添加、修改弹层 -->
		<el-dialog
			append-to-body
			:title="dialogTitle"
			:visible.sync="dialogVisible"
			class="edit-dialog-user role-share-dialog"
			left
			:close-on-click-modal="false"
		>
			<el-form
				ref="form"
				:model="formData"
				:rules="formRules"
				label-width="120px"
			>
				<el-form-item label="所属机构" prop="org">
					<el-cascader
						v-model="formData.org"
						:options="orgList"
						:disabled="isDisabled"
						ref="orgTree"
						:props="{
							value: 'orgFullNm',
							label: 'orgFullNm',
							checkStrictly: true,
							emitPath: false,
						}"
						:show-all-levels="false"
						@change="(e) => singleCheck('org', e)"
						clearable
					>
					</el-cascader>
				</el-form-item>
				<el-form-item label="用户名" prop="loginName">
					<el-input
						v-model.trim="formData.loginName"
						maxlength="20"
						clearable
						:disabled="isDisabled"
					></el-input>
				</el-form-item>
				<el-form-item label="姓名" prop="realName">
					<el-input
						v-model.trim="formData.realName"
						maxlength="10"
						clearable
						:disabled="
							formType === 2 ||
							(isEdit && formData.dataSource == 2)
						"
					></el-input>
				</el-form-item>
				<el-form-item label="手机号">
					<el-input
						v-model.trim="formData.mobile"
						maxlength="11"
						clearable
						:disabled="
							formType === 2 ||
							(isEdit && formData.dataSource == 2)
						"
					></el-input>
				</el-form-item>
				<el-form-item label="邮箱" prop="email">
					<el-input
						v-model.trim="formData.email"
						clearable
						:disabled="
							formType === 2 ||
							(isEdit && formData.dataSource == 2)
						"
					></el-input>
				</el-form-item>
				<el-form-item label="状态" prop="adminStatus">
					<el-select
						v-model="formData.adminStatus"
						placeholder="请选择"
						:disabled="formType === 2"
					>
						<el-option label="禁用" :value="0"></el-option>
						<el-option label="正常" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="可见数据范围" prop="visibleRange">
					<el-select
						v-model="formData.visibleRange"
						placeholder="请选择"
						:disabled="formType === 2"
					>
						<el-option label="仅个人信息" :value="1"></el-option>
						<el-option label="本机构信息" :value="2"></el-option>
						<el-option
							label="本机构及下辖机构信息"
							:value="3"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="分配角色"></el-form-item>
				<el-transfer
					style="padding-left: 20px"
					v-model="hasRoleList"
					:data="roleList"
					class="mb20"
					:disabled="formType === 2"
					:titles="['现有角色', '已分配角色']"
					:props="{ key: 'roleId', label: 'roleName' }"
				>
				</el-transfer>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button
					type="primary"
					@click="addAccount"
					:loading="submitLoading"
					v-if="formType !== 2"
					>确定</el-button
				>
			</span>
		</el-dialog>
		<!-- 角色分配弹层 -->
		<el-dialog
			append-to-body
			title="角色分配"
			:visible.sync="roleShareDialogVisible"
			class="edit-dialog role-share-dialog"
			:close-on-click-modal="false"
		>
			<el-transfer
				v-model="hasRoleList"
				:data="roleList"
				class="mb20"
				:titles="['现有角色', '已分配角色']"
				:props="{ key: 'roleId', label: 'roleName' }"
			>
			</el-transfer>
			<span slot="footer" class="dialog-footer">
				<el-button
					type="primary"
					@click="submit"
					:loading="submitLoading"
					>确定</el-button
				>
			</span>
		</el-dialog>
		<!-- 批量添加 -->
		<el-dialog
			title="批量添加员工"
			:visible.sync="dialogVisibleImport"
			center
			class="edit-dialog"
			:close-on-click-modal="false"
			@closed="toCloseDialogImport"
		>
			<el-form
				ref="templateForm"
				:model="templateForm"
				label-width="120px"
			>
				<el-form-item label="下载模板：">
					<el-button type="primary" class="search-btn"
						><a
							class="no-a"
							:href="`${path}excel/员工导入模板.xlsx`"
							>下载模版</a
						>
					</el-button>
				</el-form-item>

				<el-form-item label="选择上传文档：">
					<el-upload
						class="upload-dom"
						ref="upload-dom"
						:action="uploadAction"
						:headers="uploadHeader"
						:limit="1"
						:auto-upload="false"
						:on-change="uploadChange"
						:before-remove="uploadBeforeRemove"
						:on-success="uploadSucess"
						:on-remove="uploadHandleRemove"
						:before-upload="uploadBefore"
						accept=".xlsx,.xls"
						style="width: 55%"
					>
						<el-button type="primary" icon="el-icon-upload"
							>上传附件</el-button
						>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button class="search-btn" @click="toCloseDialogImport"
					>取消</el-button
				>
				<el-button
					class="search-btn"
					type="primary"
					@click="sureSubmit('templateForm')"
					>确定</el-button
				>
			</div>
		</el-dialog>
		<ImportFail
			:show="showImportFail"
			title="导入用户"
			:failObj="errorData"
			@receive="getReceive"
		/>
	</el-container>
</template>

<script>
	const userSource = [
		{ label: "健管平台", value: 1 },
		// { label: "OA平台", value: 2 },
	];
	import _valid from "@/assets/js/valid.js";
	import db from "@/assets/js/localstorage";
	import ImportFail from "@/views/supplier/components/ImportFail";
	export default {
		data() {
			function validateCheckAccount(rule, val, cb) {
				if (!val) {
					cb(new Error("请输入用户名称"));
				} else if (!_valid.checkAccount(val)) {
					cb(
						new Error(
							"用户名称格式由英文、数字及_组成的6至20位字符组成"
						)
					);
				} else {
					cb();
				}
			}
			function checkPhone(rule, val, cb) {
				if (!val) {
					cb(new Error("请输入手机号"));
				} else if (!_valid._limitPhone(val)) {
					cb(new Error("手机号格式不正确"));
				} else {
					cb();
				}
			}
			function checkEmail(rule, val, cb) {
				if (!val) {
					cb(new Error("请输入邮箱"));
				} else if (!_valid._limitemail(val)) {
					cb(new Error("请输入正确的邮箱"));
				} else {
					cb();
				}
			}
			return {
				searchBox: {
					loginName: "",
					realName: "",
					mobile: "",
					dataSource: "",
					pageNum: 1,
					pageSize: 10,
				},
				userSource,
				loading: false,
				tableHeight: 0,
				tableData: [],
				total: 0,
				dialogVisible: false,
				dialogTitle: "",
				formData: {
					loginName: "",
					realName: "",
					mobile: "",
					email: "",
					org: "",
					visibleRange: "",
					adminStatus: 1,
				},
				formRules: {
					org: [
						{
							required: true,
							message: "请选择所属机构",
							trigger: "blur",
						},
					],
					loginName: {
						required: true,
						validator: validateCheckAccount,
						trigger: "blur",
					},
					realName: {
						required: true,
						message: "请输入姓名",
						trigger: "blur",
						type: "string",
					},
					mobile: {
						required: true,
						validator: checkPhone,
						trigger: "blur",
					},
					email: {
						required: true,
						validator: checkEmail,
						trigger: "blur",
					},
					visibleRange: [
						{
							required: true,
							message: "请选择可见数据范围",
							trigger: "change",
						},
					],
				},
				adminId: "",
				isEdit: false,
				isDisabled: false,
				roleShareDialogVisible: false, //角色分配弹层
				roleList: [],
				hasRoleList: [],
				dialogLoading: false,
				submitLoading: false,
				formType: 1, // 1-新增 2-查看 3-修改
				/**
				 * 批量添加员工 -- 弹窗相关 **/
				path: process.env.BASE_URL,
				uploadHeader: { token: db.get("ACCESS_TOKEN") }, //上传header
				uploadFile: null, //上传后文件
				uploadAction: "", //提交表单地址
				dialogVisibleImport: false, // 弹窗是否展示
				templateForm: {
					tempFile: "",
				},
				showImportFail: false, //导入错误提示弹框
				errorData: {},
				orgList: [],
				orgIdInBizSys: "",
			};
		},
		components: {
			ImportFail,
		},
		filters: {
			optionsFilter(text, list) {
				let data = list.find((e) => Number(text) == e.value);
				if (data) return data.label;
				else return "";
			},
		},
		created() {
			this.$root.breadList = [
				{ name: "系统管理", link: "" },
				{ name: "用户管理", link: "" },
			];
		},
		mounted() {
			this.$nextTick(() => {
				this.listenWindow();
				this.getData();
				this.getOrgList();
			});
		},
		methods: {
			//窗口改变，重新取得高度
			listenWindow() {
				this.tableHeight = this.$refs.tableBox.offsetHeight;
				window.addEventListener("resize", () => {
					clearTimeout(this.resizeFlag);
					this.resizeFlag = setTimeout(() => {
						try {
							this.tableHeight = this.$refs.tableBox.offsetHeight;
						} catch (error) {}
					}, 300);
				});
			},
			getReceive(data) {
				this[data.key] = data.value;
			},
			/**
			 * 单独校验某个字段输入，清除错误提示
			 * @param {String} name 输入名
			 */
			singleCheck(name, e) {
				this.orgList.forEach((item) => {
					if (item.orgFullNm == e) {
						this.orgIdInBizSys = item.orgIdInBizSys;
					} else {
						item.children.forEach((list) => {
							if (list.orgFullNm == e) {
								this.orgIdInBizSys = list.orgIdInBizSys;
							}
						});
					}
				});

				this.$refs.form.validateField(name, (val) => {
					if (!val) {
						return true;
					} else {
						return false;
					}
				});
			},
			/**
			 * 批量导入员工
			 */
			// 关闭批量导入弹窗
			toCloseDialogImport() {
				this.uploadFile = null;
				this.dialogVisibleImport = false;
				this.$refs["upload-dom"].clearFiles();
				this.$refs["templateForm"].resetFields();
			},
			// -- 文件上传确定按钮
			sureSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (!this.uploadFile) {
							this.$message.warning("请选择文件");
							return;
						}
						//数据确认
						this.$refs["upload-dom"].submit();
					} else {
						return false;
					}
				});
			},
			//文件状态改变时
			uploadChange(file) {
				this.uploadFile = file;
			},
			//文件移除前
			uploadBeforeRemove(file) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			//文件上传前
			uploadBefore(file) {
				const isLt10M = file.size / 1024 / 1024 < 10;
				if (!isLt10M) {
					this.$message.error("上传文件不能超过 10MB!");
				}
				return isLt10M;
			},
			//文件移除
			uploadHandleRemove() {
				this.uploadFile = null;
				this.$refs["upload-dom"].clearFiles();
			},
			//文件上传成功
			uploadSucess(res) {
				let { code, msg } = res;
				if (code == 1) {
					this.doErrorData(res.data);
				} else {
					this.$message.error(msg);
				}
				this.uploadHandleRemove();
			},
			doErrorData(res) {
				if (res.failList && res.failList.length == 0) {
					this.$message({
						type: "success",
						message: "导入成功",
					});
					this.dialogVisibleImport = false;
				} else {
					res.failList = res.failList.map((item) => {
						return Object.keys(item).map((el) => {
							return {
								value: el,
								label: item[el],
							};
						})[0];
					});
					res.fileName = "员工导入失败信息表";
					res.headerData = 1;
					this.errorData = res;
					this.showImportFail = true;
				}
				this.getData();
			},
			search() {
				this.searchBox.pageNum = 1;
				this.getData();
			},
			getData() {
				this.loading = true;
				this.axios
					.get(this.getApiUrl("adminIndex"), {
						params: this.searchBox,
					})
					.then((res) => {
						this.loading = false;
						if (res.code === 1) {
							this.tableData = res.data.data || [];
							this.total = res.data.total;
						} else {
							this.$message.warning(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
					});
			},
			handleCurrentChange(val) {
				this.searchBox.pageNum = val;
				this.getData();
			},
			toUpOrDown(item, type) {
				let text = type === 1 ? "启用" : "禁用";
				this.$confirm(`确定${text}该用户吗？`, `${text}用户`, {
					type: "warning",
				})
					.then(() => {
						let param = {
							adminId: item.adminId,
							adminStatus: type,
						};
						this.axios
							.post(this.getApiUrl("adminShelf"), param)
							.then((res) => {
								this.submitLoading = false;
								if (res.code === 1) {
									this.$message.success("操作成功");
									this.getData();
								} else {
									this.$message.error(res.msg);
								}
							})
							.catch((err) => {
								console.log(err);
							});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: `已取消${text}操作`,
						});
					});
			},
			leftCheckChange(arr, arr2) {},
			rightCheckChange(arr, arr2) {},
			// 添加、修改账号
			toAdd(row, type) {
				if (this.$refs["form"]) {
					this.$refs["form"].clearValidate();
				}
				this.formType = type;
				if (row) {
					this.dialogTitle = type === 3 ? "修改账号" : "账号详情";
					this.getAdminView(row);
					this.adminId = row.adminId;
					this.isEdit = true;
					this.isDisabled = true;
				} else {
					this.adminId = null;
					this.dialogTitle = "添加账号";
					this.isEdit = false;
					this.isDisabled = false;
					this.formData = {
						loginName: "",
						realName: "",
						mobile: "",
						email: "",
						adminStatus: 1,
					};
				}
				this.dialogVisible = true;
				this.getAllAllotList(this.adminId, type);
			},
			// 获取详情
			getAdminView(item) {
				let p = {
					adminId: item.adminId,
				};
				this.axios
					.get(this.getApiUrl("adminView"), {
						params: p,
					})
					.then((res) => {
						if (res.code === 1) {
							let data = res.data;
							this.formData = {
								loginName: data.loginName,
								realName: data.realName,
								mobile: data.mobile,
								email: data.email,
								visibleRange: data.visibleRange || "",
								org: data.org || "",
								dataSource: data.dataSource,
								adminStatus: data.adminStatus,
							};
						} else {
							this.$message.warning(res.msg);
						}
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// 新增 or 编辑 额外增加的角色分配
			getAllAllotList(adminId, type) {
				let p = {
					adminId: adminId ? adminId : "",
				};
				this.roleList = [];
				this.hasRoleList = [];
				this.axios
					.get(this.getApiUrl("userAllotList"), {
						params: p,
					})
					.then((res) => {
						if (res.code === 1) {
							this.roleList = res.data.roleList || [];
							this.roleList.forEach((item) => {
								if (type === 2) {
									item.disabled = true;
								}
							});
							// 生成一个map，用于后面判断是否这个人不在已选的人列表中
							let roleDataMap = {};
							this.roleList.forEach((role) => {
								roleDataMap[role.roleId] = role;
							});
							if (res.data.hasRoleList) {
								res.data.hasRoleList.forEach((item) => {
									//只有这个角色可以操作的角色才放到列表中
									if (roleDataMap[item.roleId]) {
										if (type === 2) {
											item.disabled = true;
										}
										this.hasRoleList.push(item.roleId);
									}
								});
							}
						} else {
							this.$message.warning(res.msg);
						}
						this.dialogLoading = false;
					})
					.catch((err) => {
						this.dialogLoading = false;
						console.log(err);
					});
			},
			// 新增 or 编辑账号
			addAccount() {
				this.$refs["form"].validate((valid) => {
					if (!valid) {
						return false;
					}
					if (!this.hasRoleList.length) {
						this.$message.warning("请至少分配一个角色");
						return false;
					}
					this.submitLoading = true;
					let p = {
						...this.formData,
						orgCode: this.orgIdInBizSys,
						adminId: this.isEdit ? this.adminId : "",
						roleIds: this.hasRoleList.join(","),
					};
					this.axios
						.post(this.getApiUrl("adminSave"), p)
						.then((res) => {
							this.submitLoading = false;
							if (res.code === 1) {
								this.$message.success("操作成功");
								this.dialogVisible = false;
								this.getData();
							} else {
								this.$message.error(res.msg);
							}
						})
						.catch((err) => {
							this.submitLoading = false;
							console.log(err);
						});
				});
			},
			// 重置密码
			resetPassWord(row) {
				this.$confirm("此操作将使旧密码不能使用, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
					.then(() => {
						let p = {
							adminId: row.adminId,
						};
						this.axios
							.post(this.getApiUrl("adminResetPwd"), p)
							.then((res) => {
								if (res.code === 1) {
									this.$message.success(
										"重置成功，密码已经发送至邮箱" + row.email
									);
								} else {
									this.$message.error(res.msg);
								}
							})
							.catch((err) => {
								console.log(err);
							});
					})
					.catch(() => {});
			},
			// 角色分配
			roleShare(row) {
				this.hasRoleList = [];
				this.roleShareDialogVisible = true;
				this.dialogLoading = true;
				this.adminId = row.adminId;
				let p = {
					adminId: this.adminId,
				};
				this.axios
					.get(this.getApiUrl("userAllotList"), {
						params: p,
					})
					.then((res) => {
						if (res.code === 1) {
							this.roleList = res.data.roleList || [];
							// 生成一个map，用于后面判断是否这个人不在已选的人列表中
							let roleDataMap = {};
							this.roleList.forEach((role) => {
								roleDataMap[role.roleId] = role;
							});
							if (res.data.hasRoleList) {
								res.data.hasRoleList.forEach((item) => {
									//只有这个角色可以操作的角色才放到列表中
									if (roleDataMap[item.roleId]) {
										this.hasRoleList.push(item.roleId);
									}
								});
							}
						} else {
							this.$message.warning(res.msg);
						}
						this.dialogLoading = false;
					})
					.catch((err) => {
						this.dialogLoading = false;
						console.log(err);
					});
			},
			submit() {
				if (!this.hasRoleList.length) {
					this.$message.warning("请至少分配一个角色");
					return false;
				}
				this.submitLoading = true;
				let p = {
					adminId: this.adminId,
					roleIds: this.hasRoleList.join(","),
				};
				this.axios
					.post(this.getApiUrl("roleUserAllot"), p)
					.then((res) => {
						this.submitLoading = false;
						if (res.code === 1) {
							this.$message.success("操作成功");
							this.roleShareDialogVisible = false;
							this.getData();
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.submitLoading = false;
						console.log(err);
					});
			},
			/**
			 * 机构列表
			 */
			async getOrgList() {
				let res = await this.axios.get(this.getApiUrl("orgList"), {
					params: {},
				});
				let data = res?.data || [];
				this.orgList = [];
				data.forEach((item) => {
					if (item.orgLvl == 1) {
						item.children = [];
						this.orgList.push(item);
					}
				});
				data.forEach((item) => {
					this.orgList.forEach((content) => {
						if (
							item.orgLvl == 2 &&
							content.internalOrgId == item.parentOrgId
						) {
							content.children.push(item);
						}
					});
				});
			},
		},
	};
</script>

<style lang="scss" scoped type="text/scss">
	.edit-dialog-user {
		.el-dialog__body {
			padding: 20px 50px 0;
		}
	}
	.no-a {
		color: #fff;
		text-decoration: none;
	}
	.el-cascader {
		width: 100%;
	}
</style>